(async () => {
  if (!customElements.get('product-media-slider')) {
    const {
      default: Swiper,
      Navigation,
      Pagination,
      Scrollbar,
      Autoplay,
      Mousewheel,
    } = await import('swiper');

    const { Fancybox } = await import('@fancyapps/ui');

    Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, Mousewheel]);

    class ProductMediaSlider extends HTMLElement {
      constructor() {
        super();

        // Create elements
        this.mainSlider();
        this.fancybox();

        // Reduce actions (So the event can also be removed)
        this.reducer = {
          slideToVariant: (e) => this.slideToVariant(e),
        };

        // Listen for variant change and go to slide
        document.addEventListener('variant-change', this.reducer.slideToVariant);
      }

      /*
       * Create main slider
       */
      mainSlider() {
        // Check if Swiper exists
        if (typeof Swiper == 'undefined') {
          return false;
        }

        // Get swiper element
        this.swiperMain = this.querySelector('[data-product-media-slider]');

        // Get initial slide and swiper index
        let initialSlideIndex = 0;
        const initalVariant = parseInt(this.swiperMain.dataset.productMediaSlider);

        if (initalVariant) {
          const initialSlide = this.matchVariantIdWithSlide(initalVariant);
          initialSlideIndex = initialSlide ? initialSlide : initialSlideIndex;
        }

        // Swiper options
        this.swiperMainOptions = {
          direction: 'horizontal',
          initialSlide: initialSlideIndex,
          watchSlidesProgress: true,
          slidesPerView: 1,
          spaceBetween: 2,
          threshold: 10,
          mousewheel: true,
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
          },
          breakpoints: {
            768: {
              direction: 'vertical',
              slidesPerView: 'auto',
              spaceBetween: 2,
            },
          },
        };

        // Create Main slider
        this.swiperMainInstance = new Swiper(this.swiperMain, this.swiperMainOptions);

        // Rebuid Swiper in design mode
        if (Shopify.designMode && this.swiperMainInstance) {
          window.addEventListener('shopify:section:load', () => {
            this.swiperMainInstance.update();
          });
        }
      }

      /*
       * Create fancybox
       */
      fancybox() {
        // Check if Fancybox exists
        if (typeof Swiper == 'undefined') {
          return false;
        }

        Fancybox.bind('[data-fancybox]', {
          animated: false,
          showClass: false,
          mainClass: 'image-zoom',
        });
      }

      /*
       * Slide to variant
       * @Param e {object}: event object with variant
       */
      slideToVariant(e) {
        if (e?.detail?.variant?.id) {
          const slideIndex = this.matchVariantIdWithSlide(e.detail.variant.id);
          if (typeof slideIndex == 'number') {
            this.goToSlide(slideIndex);
          }
        }
      }

      /*
       * Match variant id with slide
       * @param id {int}: variant id
       */
      matchVariantIdWithSlide(id) {
        if (!id || !this.swiperMain) {
          return false;
        }

        // Get slides
        const slides = this.swiperMain.querySelectorAll('[data-product-variant-image]');

        // Match id with slides id's
        const slide = [...slides].find((slide) => {
          // Get variant id's attached to slide
          const slideVariants = parseJson(slide.dataset.productVariantImage);

          // Check if variant id match the slide variant id's
          if (slideVariants.includes(id)) {
            return slide;
          }
        });

        // return false if no slide found
        if (!slide) {
          return false;
        }

        // return matched slide index
        return getNodeIndex(slide);
      }

      /*
       * go to slide
       * @param slide {node} / {int}: slide node / index
       */
      goToSlide(slide) {
        if ((typeof slide != 'number' && typeof slide != 'object') || !this.swiperMainInstance) {
          return false;
        }

        // Get index, transform node to slide index or string to int
        const index = typeof slide == 'number' ? parseInt(slide) : getNodeIndex(slide);

        // go to slide
        this.swiperMainInstance.slideTo(index);
      }
    }

    window.ProductMediaSlider = ProductMediaSlider;

    customElements.define('product-media-slider', ProductMediaSlider);
  }
})();
